import { DataConnector } from '../domainObjects/dataConnector';
import { DataSourceType } from '../domainObjects/dataSourceType';
import { PreviewDataOptions } from '../domainObjects/previewDataOptions';
import { DataConnectorMapping } from '../domainObjects/dataConnectorMapping';
import { DataTypeConverter, DeduplicateRows, DurationBuilder, GeneralParameter } from '../domainObjects/ingestTransforms';
import { CacheKeyType, PreviewType } from '../domainObjects/transformType';

export class GetDataFarmPreviewRequest {
    userId: string;
    orgId: string;
    refineryId: string;
    nodeId: string;
    transformId: string;
    cacheKeyType:CacheKeyType;
    previewOptions: PreviewDataOptions;

    constructor(
        userId: string,
        orgId: string,
        refineryId: string,
        nodeId: string,
        transformId: string,
        cacheKeyType:CacheKeyType,
        previewOptions: PreviewDataOptions) {
        
        this.userId = userId;
        this.orgId = orgId;
        this.refineryId = refineryId;
        this.nodeId = nodeId;
        this.transformId = transformId;
        this.cacheKeyType = cacheKeyType;
        this.previewOptions = previewOptions;
    }
}
export class GetDataFarmPreviewIngestRequest {
    userId: string;
    orgId: string;
    refineryId: string;
    nodeId: string;
    cacheKeyType:CacheKeyType;
    dataConnectorMapping?: DataConnectorMapping;
    previewOptions: PreviewDataOptions;
    generalParameter: GeneralParameter;

    constructor(
        userId: string,
        orgId: string,
        refineryId: string,
        nodeId: string,
        cacheKeyType:CacheKeyType,
        previewOptions: PreviewDataOptions,
        generalParameter: GeneralParameter,
        dataConnectorMapping?: DataConnectorMapping) {
        
        this.userId = userId;
        this.orgId = orgId;
        this.refineryId = refineryId;
        this.nodeId = nodeId;
        this.cacheKeyType = cacheKeyType;
        this.generalParameter = generalParameter;
        this.dataConnectorMapping = dataConnectorMapping;
        this.previewOptions = previewOptions;
    }
}

export class GetCacheKeyRequest {
    userId: string;
    orgId: string;
    refineryId: string;
    nodeId: string;
    transformId: string;
    cacheKeyType:CacheKeyType;

    constructor(
        userId: string,
        orgId: string,
        refineryId: string,
        nodeId: string,
        transformId: string,
        cacheKeyType:CacheKeyType) {
        
        this.userId = userId;
        this.orgId = orgId;
        this.refineryId = refineryId;
        this.nodeId = nodeId;
        this.transformId = transformId;
        this.cacheKeyType = cacheKeyType;
    }
}

export class SaveIngestDataRequest {
    dataConnectorMapping?: DataConnectorMapping;
    constructor(
        dataConnectorMapping: DataConnectorMapping) {

        this.dataConnectorMapping = dataConnectorMapping;
    }
}
